import React from 'react';
import Skeleton from './Skeleton';

const SkeletonTable = ({ rows = 5, columns = 4, showHeader = true, className = '', ...props }) => {
  const renderTableHeader = () => {
    if (!showHeader) {
      return null;
    }

    return (
      <div className="skeleton-table-row">
        {Array.from({ length: columns }).map((_, index) => (
          <div key={index} className="skeleton-table-cell">
            <Skeleton variant="text" height="1rem" width="80%" />
          </div>
        ))}
      </div>
    );
  };

  const renderTableRows = () => {
    return Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex} className="skeleton-table-row">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={colIndex} className="skeleton-table-cell">
            <Skeleton
              variant="text"
              height="1rem"
              width={colIndex === 0 ? '70%' : colIndex === columns - 1 ? '60%' : '90%'}
            />
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className={`skeleton-table ${className}`} {...props}>
      {renderTableHeader()}
      {renderTableRows()}
    </div>
  );
};

export default SkeletonTable;
